<div class="chose-class_checkbox" [ngClass]="{ select: checked }" (click)="change()">
  <span>{{ label() }}</span>
</div>
